export default "__VITE_ASSET__BI6Z1Ybc__"